import React from "react";
import ColumnHeaderSelector from "./ColumnHeaderSelector";
import { Col, Form } from "react-bootstrap";

type Props = {
  assessmentName: string;
  studentIdColumnHeader: string;
  studentFNameColumnHeader: string;
  studentLNameColumnHeader: string;
  studentTeacherColumnHeader: string;
  studentGradeColumnHeader: string;
  studentRaceColumnHeader: string;
  studentGenderColumnHeader: string;
  studentELLColumnHeader: string;
  studentSLDColumnHeader: string;
  studentSpecialEducationColumnHeader: string;
  studentFreeOrReducedLunchColumnHeader: string;
  onChange: (event: React.FormEvent<any>) => void;
  columnNames: Array<string>;
  selectedColumnNames: Array<string>;
};

const ColumnHeadersSelectorPanel = (props: Props) => {
  return (
    <>
      <Form.Group>
        <Form.Label className="font-weight-bold">Assessment Name <span className="label-asterisk">*</span></Form.Label>
        <Form.Control
          required
          value={props.assessmentName}
          onChange={props.onChange}
          name={"assessmentName"}
          type="text"
          placeholder="Enter"
        />
      </Form.Group>
      <Form.Row>
        <Col>
          <ColumnHeaderSelector
            required
            name={"selectedStudentIdColumn"}
            title={"Student ID Column"}
            value={props.studentIdColumnHeader}
            onChange={props.onChange}
            columnNames={props.columnNames}
            selectedColumnNames={props.selectedColumnNames}
          />
        </Col>
        <Col>
          <ColumnHeaderSelector
            required
            name={"selectedStudentFirstNameColumn"}
            title={"Student First Name Column"}
            value={props.studentFNameColumnHeader}
            onChange={props.onChange}
            columnNames={props.columnNames}
            selectedColumnNames={props.selectedColumnNames}
          />
        </Col>
        <Col>
          <ColumnHeaderSelector
            required
            name={"selectedStudentLastNameColumn"}
            title={"Student Last Name Column"}
            value={props.studentLNameColumnHeader}
            onChange={props.onChange}
            columnNames={props.columnNames}
            selectedColumnNames={props.selectedColumnNames}
          />
        </Col>
      </Form.Row>
      <Form.Row>
        <Col>
          <ColumnHeaderSelector
            name={"selectedStudentTeacherColumn"}
            title={"Teacher Column"}
            value={props.studentTeacherColumnHeader}
            onChange={props.onChange}
            columnNames={props.columnNames}
            selectedColumnNames={props.selectedColumnNames}
          />
        </Col>
        <Col>
          <ColumnHeaderSelector
            name={"selectedStudentGradeColumn"}
            title={"Grade Column"}
            value={props.studentGradeColumnHeader}
            onChange={props.onChange}
            columnNames={props.columnNames}
            selectedColumnNames={props.selectedColumnNames}
          />
        </Col>
        <Col>
          <ColumnHeaderSelector
            name={"selectedStudentRaceColumn"}
            title={"Race Column"}
            value={props.studentRaceColumnHeader}
            onChange={props.onChange}
            columnNames={props.columnNames}
            selectedColumnNames={props.selectedColumnNames}
          />
        </Col>
        
      </Form.Row>
      <Form.Row>
        <Col>
          <ColumnHeaderSelector
            name={"selectedStudentGenderColumn"}
            title={"Gender Column"}
            value={props.studentGenderColumnHeader}
            onChange={props.onChange}
            columnNames={props.columnNames}
            selectedColumnNames={props.selectedColumnNames}
          />
        </Col>
        <Col>
          <ColumnHeaderSelector
            name={"selectedStudentELLColumn"}
            title={"ELL Column"}
            value={props.studentELLColumnHeader}
            onChange={props.onChange}
            columnNames={props.columnNames}
            selectedColumnNames={props.selectedColumnNames}
          />
        </Col>
        <Col>
          <ColumnHeaderSelector
            name={"selectedStudentSLDColumn"}
            title={"SLD Column"}
            value={props.studentSLDColumnHeader}
            onChange={props.onChange}
            columnNames={props.columnNames}
            selectedColumnNames={props.selectedColumnNames}
          />
        </Col>
        
      </Form.Row>
      <Form.Row>
        <Col>
          <ColumnHeaderSelector
            name={"selectedStudentSpecialEducationColumn"}
            title={"Special Education Column"}
            value={props.studentSpecialEducationColumnHeader}
            onChange={props.onChange}
            columnNames={props.columnNames}
            selectedColumnNames={props.selectedColumnNames}
          />
        </Col>
        <Col>
          <ColumnHeaderSelector
            name={"selectedStudentFreeOrReducedLunchColumn"}
            title={"Free or Reduced Lunch Column"}
            value={props.studentFreeOrReducedLunchColumnHeader}
            onChange={props.onChange}
            columnNames={props.columnNames}
            selectedColumnNames={props.selectedColumnNames}
          />
        </Col>
        
      </Form.Row>
    </>
  );
};

export default ColumnHeadersSelectorPanel;
